var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "rounded-bar",
    _vm._b(
      {
        attrs: {
          chartdata: _vm.timeEntriesChartdata,
          options: _vm.timeEntriesChartOptions
        }
      },
      "rounded-bar",
      _vm.$attrs,
      false
    )
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }